import React, {useEffect, useState} from 'react'
import {useHttp} from '../hooks/http.hook'
import {eyeHandler, objectLang, setErrorWindow, setLocalStorageItem, validationPassword} from "../functions"
import config from '../config.json'
import {Link, useNavigate} from "react-router-dom"
import {ModalWin} from "../elements/ModalWin"
import {LoaderClass} from "../elements/LoaderClass"
import {Button} from "react-bootstrap"

const $ = require("jquery")

export const RegisterPageForm = () => {
    setLocalStorageItem('page', 'RegisterPageForm')
    let lang = objectLang().language
    const {loading, request} = useHttp()
    const [language, setLanguage] = useState('en')
    const [email, setEmail] = useState('')
    const [firstName, setFirstName] = useState('')
    const navigate = useNavigate()
    let passOne = ''
    let passTwo = ''
    const [allowed, setAllowed] = useState(true)
    const [dataModal, setDataModal] = useState({})

    let widthWin = '600px'
    if (window.matchMedia('(max-width: 768px)').matches) {
        widthWin = window.innerWidth
    }

    useEffect(() => {
        window.M.updateTextFields()
    })

    const langHandler = event => {
        setLanguage(event.target.value)
    }
    const emailHandler = event => {
        setEmail(event.target.value)
    }
    const firstNameHandler = event => {
        setFirstName(event.target.value)
    }
    const passHandlerOne = event => {
        passOne = event.target.value
    }
    const passHandlerTwo = event => {
        passTwo = event.target.value
    }

    const registerHandler = async () => {
        lang = objectLang().language
        const l = lang.lang
        let host
        window.location.host === 'localhost:3000' ? host = config.localHost : host = config.onrender
        passOne = document.querySelector('#passOne').value
        passTwo = document.querySelector('#passTwo').value

        if (!email || !firstName) {
            setAllowed(false)
            const modal = {
                title: lang.modal.errors.title,
                desc: lang.messages.fillToForm,
                btnCancel: lang.modal.errors.btnCancel,
                btnOK: lang.modal.errors.btnOK,
                code: 591
            }
            setDataModal(modal)
            return
        }

        const validPasswords = validationPassword(passOne, passTwo, true)
        if (!validPasswords.flag) {
            setAllowed(false)
            const modal = {
                title: lang.modal.errors.title,
                desc: lang.messages[`code_${validPasswords.code}`],
                btnCancel: lang.modal.errors.btnCancel,
                btnOK: lang.modal.errors.btnOK,
                code: validPasswords.code
            }
            setDataModal(modal)
            return
        }
        const password = validPasswords.res

        try {
            const data = await request(
                `${host}/api/user/register/`,
                'POST',
                {
                    email: btoa(email),
                    password: btoa(password),
                    firstName: firstName,
                    language: language,
                })

            if (data.status === 201 && data.code === 609) {
                navigate(`/${l}/verify?uid=${data.userId}`, { replace: true })
            } else {
                setAllowed(false)
                setDataModal(setErrorWindow(
                    lang.modal.errors.title,
                    data.code,
                    lang.messages[`code_${data.code}`],
                    '',
                    '',
                    lang.modal.errors.btnCancel,
                    'replaceToMain'
                ))
            }
        } catch (e) {
            window.location.replace(`/${l}`)
        }
    }

    if (loading) {
        return <LoaderClass/>
    }

    if (!allowed) {
        return <ModalWin data={dataModal}/>
    }

    // reloadOnceWithoutCache()
    return (
        <>
            <div className={'pt-3 d-flex flex-wrap justify-content-center'}>
                <div className={'d-flex w-100 justify-content-center'}>
                    <h1 className={'mb-4 text-center fw-bold'}>{lang.body.registerPage.title}</h1>
                </div>
                <form id={'registration-form'}
                      className={'mt-1 mb-2 ps-3 pe-3 d-flex justify-content-center rounded-5'}
                      style={{minWidth: widthWin}}>
                    <fieldset className={'teal p-3 border border-dark-subtle border-opacity-25 rounded-3 w-100'}>
                        <div className={'ps-1 pe-3 d-flex align-items-center'}>
                            <legend id={"legend"} className={'fs-3 col col-7'}>{lang.body.registerPage.titleButton}</legend>
                            <Button className={'m-3 ps-2 pe-2 p-0 fs-5 col col-5 btn-light border-opacity-25 border-black'}
                                    onClick={() => {
                                        navigate(`/${lang.lang}/register-social`, { replace: true })
                                        // window.location.replace(`/${lang.lang}/register-social`)
                                    }}>
                                {lang.body.registerPage.buttonSocial}
                            </Button>
                        </div>
                        <div className={"mb-3"} id={"divEmail"}>
                            <label
                                id={"label-email"}
                                htmlFor={"email"}
                                className={"form-label"}>
                                {lang.body.registerPage.labelEmail}
                            </label>
                            <input
                                required
                                type={"text"}
                                name={"email"}
                                id={"email"}
                                onChange={emailHandler}
                                className={"form-control"}
                                placeholder={lang.body.registerPage.placeholderEmail}
                            />
                        </div>
                        <div className={"mb-3"} id={"divFirstName"}>
                            <label
                                id={"label-firstname"}
                                htmlFor={"firstName"}
                                className={"form-label"}>
                                {lang.body.registerPage.labelFirstName}
                            </label>
                            <input
                                required
                                type={"text"}
                                name={"firstName"}
                                id={"firstName"}
                                onChange={firstNameHandler}
                                className={"form-control"}
                                placeholder={lang.body.registerPage.placeholderFirstName}
                            />
                        </div>
                        <div className={"mb-3"} id={"divLanguage"}>
                            <label
                                id={"label-language"}
                                htmlFor={"language"}
                                className={"form-label"}>
                                {lang.body.registerPage.labelLanguage}
                            </label>
                            <select
                                name={"language"}
                                id={"languageReg"}
                                className={"form-control"}
                                onChange={langHandler}>
                                <option value={"en"}>English</option>
                                <option value={"fr"}>Francais</option>
                                <option value={"ru"}>Русский</option>
                                <option value={"he"}>עברית</option>
                                <option value={"ge"}>Deutsch</option>
                                <option value={"ar"}>عربي</option>
                            </select>
                        </div>
                        <div className={"mb-3"} id={"divPassOne"}>
                            <label
                                id={"label-password-one"}
                                htmlFor={"passOne"}
                                className={"form-label"}>
                                {lang.body.registerPage.labelPasswordOne}
                            </label>
                            <div className={"input-group"}>
                                <input
                                    autoComplete={"off"}
                                    autoFocus={false}
                                    required
                                    type={"password"}
                                    name={"passOne"}
                                    id={"passOne"}
                                    onChange={passHandlerOne}
                                    className={"form-control"}
                                    placeholder={lang.body.registerPage.placeholderPasswordOne}
                                />
                                <div className={"input-group-prepend"}>
                                    <div className={"div-eye input-group-text"}>
                                        <Link to={``}
                                              className={"eye-register"}
                                              onClick={() => {
                                                  eyeHandler($('#eye-open-close-one'), $('#passOne'))
                                              }}>
                                            <i id={"eye-open-close-one"} className={"fa-regular fa-eye-slash"}/>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={"mb-3"} id={"divPassTwo"}>
                            <label
                                id={"label-password-two"}
                                htmlFor={"passTwo"}
                                className={"form-label"}>
                                {lang.body.registerPage.labelPasswordTwo}
                            </label>
                            <div className={"input-group"}>
                                <input
                                    autoComplete={"off"}
                                    autoFocus={false}
                                    required
                                    type={"password"}
                                    name={"passTwo"}
                                    id={"passTwo"}
                                    onChange={passHandlerTwo}
                                    className={"form-control"}
                                    placeholder={lang.body.registerPage.placeholderPasswordTwo}
                                />
                                <div className={"input-group-prepend"}>
                                    <div className={"div-eye input-group-text"}>
                                        <Link to={``}
                                              className={"eye-register"}
                                              onClick={() => {
                                                  eyeHandler($('#eye-open-close-two'), $('#passTwo'))
                                              }}>
                                            <i id={"eye-open-close-two"} className={"fa-regular fa-eye-slash"}/>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button
                            id={'register'}
                            type={'button'}
                            onClick={registerHandler}
                            disabled={loading}
                            className={"btn btn-primary mt-4"}>
                            {lang.body.registerPage.btnRegister}
                        </button>
                    </fieldset>
                </form>
            </div>
        </>
    )
}
